<template>
  <div style="padding: 32px;overflow-y: hidden;">
    <div>
      <div class="subscription-container">
        <div v-if="logoDisplay"
             class="subscription-logo">
          <img :src='logo' alt="Logo" class="logo-image"/>
        </div>

        <v-icon
            v-if="showClose"
            @click="closeDialog"
            class="header-text"
            style="position: absolute; top: 12px; right: 12px; cursor: pointer; padding: 23px;"
        >
          fas fa-xmark
        </v-icon>

        <div class="subscription-title">
          {{ title }}
        </div>
      </div>

      <div class="subscription-info-content">
        <slot>
          <div v-html="text"></div>
        </slot>
      </div>

      <div v-if="cardDisplay">
        <v-card class="selected-card pa-4" elevation="2">
          <v-row style="margin-top: 4px;margin-bottom:23px;">
            <v-col cols="12" md="5" class="d-flex justify-center">
              <div style="height: 160px;width: 216px; margin: 0 23px;">
                <v-card
                    class="confirmation-card"
                    elevation="2"
                    shaped
                    outlined
                >
                  <div class="subscription-title">
                  <span :class="subscriptionType.mensuel == 0 ? 'free-label' : 'star-label'">
                    {{ subscriptionType.mensuel == 0 ? 'FREE' : '★'.repeat(subscriptionType.id - 1) }}
                  </span>
                    <span class="subscription-title">{{ formattedTitle(subscriptionType) }}</span>
                  </div>
                  <div class="subscription-subtitle" style="padding-bottom: 16px;">
                    <span>{{ formattedSubscriptionMaxPaie(subscriptionType) }}</span>
                  </div>
                  <div class="desc-abo">
                    {{ subscriptionType.description }}
                  </div>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" md="7">
              <div class="right-title">{{ rightLabel }}</div>
              <ul class="right-list">
                <li v-for="(feature, index) in featureList" :key="index">
                  {{ feature }}
                </li>
              </ul>
              <div class="section-selected-subscription-url">
                <a href="https://www.cheque-intermittents.com/pricing/?origine=ci24" class="selected-subscription-url"
                   target="_blank"
                   rel="noopener">
                  {{ labelUrl }}
                </a>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>

      <div class="d-flex flex-column pt-3" style="margin-top: 10px; gap: 10px">
        <div v-for="(button, index) in buttons"
             :key='index'>
          <loader-button v-if="button.show"
                         :label="button.label"
                         :disabled="button.disabled"
                         :outlined="button.outlined"
                         :fullWidth="true"
                         @callback="button.callback">
          </loader-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import {defineComponent, type PropType} from "vue";
import type SubscriptionType from "@/generated/classes/SubscriptionType.ts";
import type Button from "@/framework/base/classes/Button.ts";

export default defineComponent({
  components: {
    LoaderButton,
  },
  props: {
    showClose: {
      type: Boolean,
      default: true,
    },
    logoDisplay: {
      type: Boolean,
    },
    logo: {
      type: String,
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    cardDisplay: {
      type: Boolean,
    },
    subscriptionType: {
      type: Object as PropType<SubscriptionType>,
    },
    rightLabel: {
      type: String,
    },
    featureList: {
      type: Array
    },
    labelUrl: {
      type: String,
    },
    buttons: {
      type: Array as PropType<Button[]>,
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    formattedTitle(option: SubscriptionType) {
      return option.label.charAt(0).toUpperCase() + option.label.slice(1).toLowerCase()
    },
    formattedSubscriptionMaxPaie(option: SubscriptionType) {
      let label = '';
      if (option.maxPaies > 0) {
        label = 'Jusqu’à ' + option.maxPaies + ' bulletins de paie par an';
      } else if (option.mensuel == 0) {
        label = 'Sans abonnement et sans engagement';
      } else {
        label = 'Nombre illimité de bulletins de paie';
      }
      return label;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
  }
})
</script>

<style>
.logo-image {
  width: 83px;
  height: 77px;
}

.subscription-title {
  font-size: 22px;
  font-weight: 500;
  color: #171A1C;
}

.subscription-info-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 16px;
  padding-bottom: 48px;
  font-size: 16px;
  font-weight: 400;
  color: #135253;
  width: 100%;
}

.selected-card {
  background-color: #F1F3F4;
  border-radius: 15px;
}

.confirmation-card {
  background-color: #FFFFFF;
  border-radius: 16px;
  padding: 24px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  letter-spacing: 0;
}

.right-title {
  font-weight: 400;
  font-size: 14px;
}

.right-list {
  font-weight: 400;
  font-size: 14px;
}

.selected-subscription-url {
  font-size: 14px;
  font-weight: 500;
  color: #E31F1C;
}

.section-selected-subscription-url {
  padding: 16px;
  padding-left: 32px;
  justify-content: center;
  align-items: center;
}
</style>
